/** Firebase org ids for white-label store apps — skipped as default org when user belongs to multiple. */
export const WHITE_LABEL_ORGANIZATION_IDS = new Set([
  'ludafit',
  'bravus',
  'akm',
  '-Ou9mnYqcBS2rlPvZSIQ',
  '-Oy4-hLrRKrjlD5NsvBm',
  '-O9kk5aG_j8eL4CMcXln',
  '-OOUlSEU5BbgEAgopvhm',
  '-Oynr4k4KtH9OCXdimt-',
  '-OjbierPQHg6xtSdlqkp',
  '-OyiZufeOdr5n899AdZI',
  '-O5oKGECW2Yrj5LgMnlA',
  '-NyqG-n4NHtc194Hfw-7',
  '-OwXayf4fNaEXkmlXndF',
]);
